import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  fr: {
    nav: {
      accueil: "Accueil",
      experiences: "Expériences",
      forfaits: "Forfaits",
      equipement: "Équipement",
      location: "Location",
      voiceover: "Voice Over",
      soumission: "Soumission",
    },
    hero: {
      title_line1: "Production",
      title_line2: "événementielle",
      title_line3: "clé en main.",
      subtitle: "Son professionnel, éclairage club & laser, animation, DJ Booth Trailer, machine à mousse, décors — tout inclus.",
      cta_reserve: "Soumission gratuite",
      cta_call: "Appeler : 514 433-0846",
    },
    slides: {
      carshow: { tag: "Carshow", subtitle: "DJ Booth Trailer unique au Québec" },
      beach: { tag: "Beach Party", subtitle: "Ambiance été, énergie festival" },
      corpo: { tag: "Corporatif", subtitle: "Gala, soirée VIP, événement premium" },
      theme: { tag: "Soirée thématique", subtitle: "Show laser, éclairage immersif" },
      foam: { tag: "Foam Party", subtitle: "Machine à mousse, effet WOW garanti" },
    },
    services: {
      section_tag: "Ce qu'on fait",
      title: "Nos Expériences",
      title_accent: "Signatures",
      subtitle: "Chaque événement est unique. On s'adapte à votre vision avec un service complet et professionnel.",
    },
    packages: {
      section_tag: "Forfaits clé en main",
      title: "On s'occupe de",
      title_accent: "tout.",
      subtitle: "Choisissez votre forfait ou contactez-nous pour une proposition 100% adaptée à votre événement.",
      cta: "Obtenir ce forfait",
      popular: "Populaire",
    },
    equipment: {
      section_tag: "Location d'équipement",
      title: "Équipement",
      title_accent: "pro.",
      subtitle: "Disponible en forfait ou en location séparée. Tout notre équipement est professionnel et entretenu.",
      cta: "Demander un devis",
      bottom_text: "Besoin d'équipement spécifique? Contactez-nous pour un devis personnalisé.",
    },
    voiceover: {
      section_tag: "Voice Over",
      title: "Service",
      title_accent: "Voice Over",
      subtitle_text: "Professionnel & sur mesure",
      description: "Besoin d'une voix off pour votre événement, vos annonces, intros DJ, vidéos promotionnelles ou messages d'accueil? Notre service Voice Over professionnel donne le ton parfait à vos projets.",
      services: ["Annonces & intros DJ personnalisées", "Voice over pour vidéos promo", "Messages d'accueil téléphonique", "Narration événementielle", "Jingles & identité sonore", "Annonces de commanditaires"],
      cta: "Demander un Voice Over",
      examples_title: "Exemples Voice Over",
      add_mp3: "Ajoutez vos fichiers MP3 depuis le panneau admin",
    },
    testimonials: {
      section_tag: "Témoignages",
      title: "Ce qu'ils",
      title_accent: "disent.",
    },
    gallery: {
      section_tag: "Nos événements",
      title: "Galerie",
      title_accent: "photo.",
    },
    features: {
      section_tag: "L'avantage DJMIX",
      title: "Pourquoi",
      title_accent: "nous?",
      items: [
        { title: "Son professionnel", desc: "Système adapté au lieu, intérieur ou extérieur. Qualité studio, puissance festival." },
        { title: "Éclairage club & laser", desc: "Light show complet, lasers, stroboscopes, ambiance immersive garantie." },
        { title: "Animation adaptée", desc: "MC professionnel qui lit la foule. Énergie sur mesure pour votre événement." },
        { title: "Installation clé en main", desc: "On arrive, on installe, on gère. Vous n'avez qu'à profiter du show." },
        { title: "Réponse rapide & fiable", desc: "Soumission express et planification efficace. On ne laisse rien au hasard." },
      ],
    },
    contact: {
      section_tag: "Soumission express",
      title_line1: "Une organisation simple.",
      title_line2: "Un résultat spectaculaire.",
      subtitle: "Remplis la soumission et on te répond rapidement avec une proposition adaptée à ta date, ton lieu et ton budget.",
      first_name: "Prénom",
      last_name: "Nom",
      email: "Email",
      phone: "Téléphone",
      event_type: "Type d'événement",
      event_type_placeholder: "Choisir un type d'événement",
      event_date: "Date de l'événement",
      start_time: "Heure de début",
      end_time: "Heure de fin",
      location: "Ville / Lieu",
      location_placeholder: "Ex: Montréal, Parc Jean-Drapeau",
      num_people: "Nombre de personnes",
      duration: "Durée",
      duration_placeholder: "Choisir une durée",
      options: "Options souhaitées",
      budget: "Budget approximatif",
      budget_placeholder: "Choisir un budget",
      message: "Message additionnel",
      message_placeholder: "Détails supplémentaires, demandes spéciales...",
      submit: "Obtenir ma soumission",
      success_title: "Soumission reçue!",
      success_text: "Merci! On te revient rapidement avec une proposition adaptée.",
      new_quote: "Nouvelle soumission",
      error: "Une erreur est survenue. Veuillez réessayer.",
      event_types: ["Événements corporatifs", "Party privé / Fête", "Graduation", "Saint-Jean / Noël / Jour de l'an", "Gala / événement sportif", "Carshow (DJ Booth Trailer)", "Beach Party", "Foam Party", "Location (sonorisation / lasers / DJ Booth)", "Voice Over"],
      duration_options: ["3h", "4h", "5h", "Soirée complète"],
      options_list: ["Sonorisation", "Booth DJ intérieur", "Booth DJ extérieur (Trailer)", "Éclairage", "Micro / animation", "Machine à mousse", "Décors"],
      budget_options: ["Moins de 500$", "500$ – 1000$", "1000$ – 2000$", "2000$+"],
    },
    footer: {
      nav_title: "Navigation",
      contact_title: "Contact",
      description: "Production événementielle clé en main. Son, éclairage, animation, DJ Booth Trailer, location d'équipement — partout au Québec.",
      copyright: "Les Productions Djmix.ca réalisé par Martin Nadeau — Tous droits réservés 2026",
    },
  },
  en: {
    nav: {
      accueil: "Home",
      experiences: "Experiences",
      forfaits: "Packages",
      equipement: "Equipment",
      location: "Rentals",
      voiceover: "Voice Over",
      soumission: "Quote",
    },
    hero: {
      title_line1: "Event",
      title_line2: "production",
      title_line3: "turnkey.",
      subtitle: "Professional sound, club lighting & lasers, MC, DJ Booth Trailer, foam machine, décor — all included.",
      cta_reserve: "Free quote",
      cta_call: "Call: 514 433-0846",
    },
    slides: {
      carshow: { tag: "Car Show", subtitle: "One-of-a-kind DJ Booth Trailer in Quebec" },
      beach: { tag: "Beach Party", subtitle: "Summer vibes, festival energy" },
      corpo: { tag: "Corporate", subtitle: "Gala, VIP night, premium event" },
      theme: { tag: "Themed Night", subtitle: "Laser show, immersive lighting" },
      foam: { tag: "Foam Party", subtitle: "Foam machine, guaranteed WOW effect" },
    },
    services: {
      section_tag: "What we do",
      title: "Our Signature",
      title_accent: "Experiences",
      subtitle: "Every event is unique. We adapt to your vision with a complete, professional service.",
    },
    packages: {
      section_tag: "Turnkey packages",
      title: "We handle",
      title_accent: "everything.",
      subtitle: "Choose your package or contact us for a 100% tailored proposal for your event.",
      cta: "Get this package",
      popular: "Popular",
    },
    equipment: {
      section_tag: "Equipment rental",
      title: "Pro",
      title_accent: "equipment.",
      subtitle: "Available as a package or separate rental. All our equipment is professional and maintained.",
      cta: "Request a quote",
      bottom_text: "Need specific equipment? Contact us for a customized quote.",
    },
    voiceover: {
      section_tag: "Voice Over",
      title: "Voice Over",
      title_accent: "Service",
      subtitle_text: "Professional & custom",
      description: "Need a voice-over for your event, announcements, DJ intros, promo videos, or welcome messages? Our professional Voice Over service sets the perfect tone for your projects.",
      services: ["Custom DJ announcements & intros", "Voice over for promo videos", "Phone greeting messages", "Event narration", "Jingles & sonic branding", "Sponsor announcements"],
      cta: "Request a Voice Over",
      examples_title: "Voice Over Examples",
      add_mp3: "Add your MP3 files from the admin panel",
    },
    testimonials: {
      section_tag: "Testimonials",
      title: "What they",
      title_accent: "say.",
    },
    gallery: {
      section_tag: "Our events",
      title: "Photo",
      title_accent: "gallery.",
    },
    features: {
      section_tag: "The DJMIX advantage",
      title: "Why",
      title_accent: "us?",
      items: [
        { title: "Professional sound", desc: "System adapted to the venue, indoor or outdoor. Studio quality, festival power." },
        { title: "Club lighting & lasers", desc: "Full light show, lasers, strobes, guaranteed immersive experience." },
        { title: "Adapted animation", desc: "Professional MC who reads the crowd. Custom energy for your event." },
        { title: "Turnkey setup", desc: "We arrive, set up, and manage. All you have to do is enjoy the show." },
        { title: "Fast & reliable", desc: "Express quote and efficient planning. We leave nothing to chance." },
      ],
    },
    contact: {
      section_tag: "Express quote",
      title_line1: "Simple organization.",
      title_line2: "Spectacular result.",
      subtitle: "Fill out the form and we'll get back to you quickly with a proposal tailored to your date, venue, and budget.",
      first_name: "First name",
      last_name: "Last name",
      email: "Email",
      phone: "Phone",
      event_type: "Event type",
      event_type_placeholder: "Choose an event type",
      event_date: "Event date",
      start_time: "Start time",
      end_time: "End time",
      location: "City / Venue",
      location_placeholder: "Ex: Montréal, Parc Jean-Drapeau",
      num_people: "Number of people",
      duration: "Duration",
      duration_placeholder: "Choose a duration",
      options: "Desired options",
      budget: "Approximate budget",
      budget_placeholder: "Choose a budget",
      message: "Additional message",
      message_placeholder: "Additional details, special requests...",
      submit: "Get my quote",
      success_title: "Quote received!",
      success_text: "Thank you! We'll get back to you shortly with a tailored proposal.",
      new_quote: "New quote",
      error: "An error occurred. Please try again.",
      event_types: ["Corporate events", "Private party", "Graduation", "Holiday event (Christmas / New Year's)", "Gala / sports event", "Car Show (DJ Booth Trailer)", "Beach Party", "Foam Party", "Rental (sound / lasers / DJ Booth)", "Voice Over"],
      duration_options: ["3h", "4h", "5h", "Full evening"],
      options_list: ["Sound system", "Indoor DJ Booth", "Outdoor DJ Booth (Trailer)", "Lighting", "Mic / MC", "Foam machine", "Décor"],
      budget_options: ["Under $500", "$500 – $1,000", "$1,000 – $2,000", "$2,000+"],
    },
    footer: {
      nav_title: "Navigation",
      contact_title: "Contact",
      description: "Turnkey event production. Sound, lighting, animation, DJ Booth Trailer, equipment rental — across Quebec.",
      copyright: "Les Productions Djmix.ca made by Martin Nadeau — All rights reserved 2026",
    },
  },
};

const LangContext = createContext();

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("djmix_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("djmix_lang", lang);
  }, [lang]);

  const t = translations[lang];
  const toggle = () => setLang(l => l === "fr" ? "en" : "fr");

  return (
    <LangContext.Provider value={{ lang, t, toggle }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
